import React from 'react'
import { Helmet } from 'react-helmet'
import { get } from 'lodash'
import connect from './tools/connect'
import initializeSkin from './tools/skinAd/index'
import updateUtm from './tools/analytics/utm'
import pageStore from './redux/page/store'
import PopupView from './views/Popup'
import Share from './views/Share'
import ErrorPage from './views/ErrorPage'
import CookieConsent from '~/components/CookieConsent'
import AppStoreSuggestion from '~/components/AppStoreSuggestion'
import { trackEvent } from '~/tools/analytics/cleverTap'
import { nestTabModules, applyModuleData } from "~/Modules"
import SkeletonLoader from '~/components/skeletonLoader'
import PageSpinner from '~/components/PageSpinner'
import lazyLoad from './tools/lazy-load-images'
import NavFocusSkipper from '~/components/NavFocusSkipper'
import { ima3, platform } from './tools/externalSDK'
import { signupOrSignIn } from '~/tools/signupOrSignIn'
import './App.css'
/*  
    Most pages use slick so we are importing it at the Base 
    so that these imports are not needed 
    everytime the <Slider /> component is used.
*/
import 'slick-carousel/slick/slick.css'
import '~/modules/Carousel/slick-theme.css'
import '~/modules/Carousel/style.scss'
import LazyLoadModules from './LazyLoadModules';
import TabNavBar from '~/components/TabNavBar'
import {updatepageStyle} from '~/tools/getPageLevelStyling'

import {
  cookieDeclaration, 
  adsRemarketingEvent,  
  webConfigurationEvent } from '~/tools/analytics/gtmTags'

class App extends React.Component {
  
  constructor() {
    super()
    this.showCookieConsent = this.shouldShowCookieConsent()
    this.myRef = React.createRef();
    this.loadMore = false
    this.state = {
      pageReload : false
    }
  }

  // TEMPORARY: whether we show the cookie consent or not should depend on an AppCMS setting
  shouldShowCookieConsent() {
    return !window.settings.internalName.includes('hoichoi') && !window.settings.internalName.includes('universal')
  }

  componentDidMount() {
    updateUtm()
    ima3()
    platform()
    initializeSkin(get(this.state, 'page.data.id'))
    setTimeout(lazyLoad, 2000)
    window && window.settings && window.settings.features && window.settings.features.enablePWA && window.addEventListener('beforeinstallprompt',event => { window.deferredPrompt = event })
    document.addEventListener("scroll", lazyLoad);
    window.addEventListener("resize", lazyLoad);
    window.addEventListener("orientationchange", lazyLoad)

    if (!window.SERVER_SIDE_RENDERING && window.sessionStorage && !window.sessionStorage.getItem('isApp')) {
      cookieDeclaration();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.page !== prevState.page) {
      var { title } = this.state.page || {}

      adsRemarketingEvent('page_view', {
        'source': 'Web', 
        'pageName': title,
        'Login-Signup' : signupOrSignIn()
        }
      );
      webConfigurationEvent('page_view', {
        'source': 'Web', 
        'pageName': title
      })
    }
  }

  triggerPageViewd() {
    var { title } = this.state.page || {}
    if (title) {
      var lastActivity = null
      if (document.referrer && document.referrer !== window.location.href) {
        lastActivity = document.referrer
      }
      
      trackEvent('Page Viewed', {
        pageName: title,
        pageURL: window.location.href,
        lastActivityName: lastActivity,
        source: lastActivity,
        platform: 'Web'
      })
    const socialMedia = window.settings.socialMedia
    const facebook = socialMedia && socialMedia.facebook 
    const pixelId = facebook && facebook.pixelId
    if (pixelId) {
      window.fbq('track', 'PageView');
    }
  }
  }
  render() {
    var { modules, layouts, route } = this.state.page || {}
    var classes = ['app', 'appcms', window.SERVER_SIDE_RENDERING ? 'server-side-rendering' : '']
    var currentPage = window.location.pathname;
    const page = path => get(this.state.page, path)

    // override styling with page specific styling if flag enabled
    if(get(this.state, 'page.styles.enableStyle') === true) {
      updatepageStyle(this.state.page && this.state.page.styles);
    }

    if (this.state.fetchingPage || this.state.adobeStatus) {
      if (currentPage.includes("/user")) {
        return !window.SERVER_SIDE_RENDERING && <PageSpinner color={window.settings.brand.cta.primary.backgroundColor} />
      } else {
        return !window.SERVER_SIDE_RENDERING && <SkeletonLoader />
      }
    }

    return (
      <div ref={el => this.wrapper = el}>
        <div ref={this.myRef} className={classes.join(' ')}>
          <NavFocusSkipper />

          <Helmet
            onChangeClientState={(newState) => this.triggerPageViewd(newState.title)}>
            <link rel="alternate" href={window.location.href} hreflang={page('lang') || 'en'} />
            {window && window.settings && window.settings.images && window.settings.images.favicon && window.settings.images.favicon["16"] && <link rel="icon" type="image/png" sizes="16x16" href={get(window.settings, 'images.favicon.16')} />}
            {window && window.settings && window.settings.images && window.settings.images.favicon && window.settings.images.favicon["32"] && <link rel="icon" type="image/png" sizes="32x32" href={get(window.settings, 'images.favicon.32')} />}
            {window && window.settings && window.settings.images && window.settings.images.favicon && window.settings.images.favicon.ico && <link rel="shortcut icon" type="image/x-icon" href={get(window.settings, 'images.favicon.ico')} /> }
            <link href={window.settings.brand.general.fontUrl} rel="stylesheet" />
            {window && window.settings && window.settings.features && window.settings.features.enablePWA && <meta name="apple-mobile-web-app-capable" content="yes"/>}
            {window && window.settings && window.settings.features && window.settings.features.enablePWA && <meta name="apple-mobile-web-app-status-bar-style" content="black"/>}
            {window && window.settings && window.settings.features && window.settings.features.enablePWA && <meta name="apple-mobile-web-app-title" content={(window.settings && window.settings.site) || ""}/>}
            {window && window.settings && window.settings.features && window.settings.features.enablePWA && <link rel="apple-touch-icon" sizes="72x72" href={(window.settings && window.settings.images && window.settings.images.pwaLogo && window.settings.images.pwaLogo.pwaLogo72x72) || "" }/>}
            {window && window.settings && window.settings.features && window.settings.features.enablePWA && <link rel="apple-touch-icon" sizes="96x96" href={(window.settings && window.settings.images && window.settings.images.pwaLogo && window.settings.images.pwaLogo.pwaLogo96x96) || "" }/>}
            {window && window.settings && window.settings.features && window.settings.features.enablePWA && <link rel="apple-touch-icon" sizes="128x128" href={(window.settings && window.settings.images && window.settings.images.pwaLogo && window.settings.images.pwaLogo.pwaLogo128x128) || "" }/>}
            {window && window.settings && window.settings.features && window.settings.features.enablePWA && <link rel="apple-touch-icon" sizes="144x144" href={(window.settings && window.settings.images && window.settings.images.pwaLogo && window.settings.images.pwaLogo.pwaLogo144x144) || "" }/>}
            {window && window.settings && window.settings.features && window.settings.features.enablePWA && <link rel="apple-touch-icon" sizes="152x152" href={(window.settings && window.settings.images && window.settings.images.pwaLogo && window.settings.images.pwaLogo.pwaLogo152x152) || "" }/>}
            {window && window.settings && window.settings.features && window.settings.features.enablePWA && <link rel="apple-touch-icon" sizes="192x192" href={(window.settings && window.settings.images && window.settings.images.pwaLogo && window.settings.images.pwaLogo.pwaLogo192x192) || "" }/>}
            {window && window.settings && window.settings.features && window.settings.features.enablePWA && <link rel="apple-touch-icon" sizes="384x384" href={(window.settings && window.settings.images && window.settings.images.pwaLogo && window.settings.images.pwaLogo.pwaLogo384x384) || "" }/>}
            {window && window.settings && window.settings.features && window.settings.features.enablePWA && <link rel="apple-touch-icon" sizes="512x512" href={(window.settings && window.settings.images && window.settings.images.pwaLogo && window.settings.images.pwaLogo.pwaLogo512x512) || "" }/>}
            {window && window.settings && window.settings.features && window.settings.features.enablePWA && <link rel="apple-touch-startup-image" href={(window.settings && window.settings.images && window.settings.images.pwaLogo && window.settings.images.pwaLogo.pwaLogo512x512) || "" }/>}
            {window && window.settings && window.settings.features && window.settings.features.enablePWA && <meta name="theme-color" content={(window.settings && window.settings.brand && window.settings.brand.general && window.settings.brand.general.backgroundColor) || "#000000"} />}
          </Helmet>
          {window.settings.skinAdTag && <div id="viewlift-site-skin"></div>}
          
          <div role="main" className={`modules ` + (window.settings.skinAdTag && 'skin-ad')}>
            
            {this.loaded && window.settings.features.app_download_suggestion &&
              <AppStoreSuggestion />
            }
            {
              this.loaded &&
              this.renderModules(layouts, modules)
            }
            <LazyLoadModules pageReload={this.loadMore} layouts={layouts} page={this.state.page}/>
          </div>
          {window && window.settings && window.settings.features && window.settings.features.enablePWA && <TabNavBar/>}
          {this.showCookieConsent &&
            <CookieConsent />
          }
          {this.errored && <ErrorPage error={this.state.page.error} />}
          {this.loaded && <PopupView />}
          {this.loaded && <Share />}
        </div>
      </div>
    )
  }

  get errored() {
    return this.state.page.error != null;
  }

  get loaded() {
    return this.state.page && !this.state.page.error
  }

  renderModules(layouts, modules) {
    /*
        This nestTabModules conditional was added because the Template Builder does not currently
        have a way to support nesting. This is basically a hacky workaround that splits up the modules
        and nests them for pages that have a Tabs Module.
    */
    let tabModule = layouts.filter(moduleLayout => {
      if (!moduleLayout.view) {
        return false;
      }
      return moduleLayout.view.includes('Tabs');
    })

    if (tabModule.length > 0) {
      return nestTabModules(layouts, modules, tabModule);
    }
    else {
      return applyModuleData(layouts, modules)
    }
  }
}

connect(App, state => ({ page: state.data, fetchingPage: state.fetchingPage, adobeStatus: state.adobeStatus }), pageStore)

export default App;
